import { Directive, ElementRef, inject, OnDestroy, OnInit, Renderer2 } from "@angular/core";
import { ResizeWindowService } from "@lib/base/services/resize-window.service";
import { Subscription } from "rxjs";

@Directive({
    selector: "[appWindowLayoutDirective]",
})
export class WindowLayoutDirective implements OnInit, OnDestroy {
    private subscription?: Subscription;
    private readonly el = inject(ElementRef);
    private readonly renderer = inject(Renderer2);
    private readonly windowResizeService = inject(ResizeWindowService);

    ngOnInit(): void {
        this.subscription = this.windowResizeService.isMobile
            .subscribe((result) => {
                if (result) {
                    this.renderer.addClass(this.el.nativeElement, "mobile");
                } else {
                    this.renderer.removeClass(this.el.nativeElement, "mobile");
                }
            });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }
}
